export default __webpack_public_path__ + "dist/media/ArchiveNda.40d4c6ec.svg";